import React, { useEffect } from "react";
import { Header, Sidebar } from "../Layout";
import { Link, useHistory} from "react-router-dom";
import { getProjectStatusList } from "../../actions/projectActions";
import { getPartners } from "../../actions/partnerActions";
import { useSelector, useDispatch } from "react-redux";
import DataTablesPartner from "./DataTablesPartner";
import { MEMBER } from '../../constants/constants';

const Partners = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const { user} = useSelector(state=> state.auth);
    // const { projects } = useSelector(state=> state.projectStore);
    const { partners } = useSelector(state=> state.partnerStore);
    // const [inputProjectData, setProjectData] = useState()
   
    useEffect(() => {
        if (user.userType === MEMBER) history.push('/')
       // dispatch(getProjectList());
        dispatch(getPartners());
        dispatch(getProjectStatusList());
    }, [user, dispatch, history])
 
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Partners</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Partners</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix py-3">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                                <h3 className="text-bold"><strong>Partners</strong></h3>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 text-right">
                            {/* <Link to='/invite-partner' className="header-dropdown dropdown dropdown-animated scale-left btn custum-bg-warning text-right text-white"><i className="fa fa-plus-circle mr-2"></i>New Partner</Link> */}
                        </div>
                    </div>
                    <div className="row clearfix">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded">
                                </div>
                                <div className="body text-center card-body-shadow">
                                    <DataTablesPartner data={partners } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Partners;